import React, { Dispatch, FC, SetStateAction } from "react";
import { WidgetLengthPickerLine } from "./WidgetLengthPickerLine";

export interface WidgetBorderRadiusPickerProps {
    readonly label?: string;
    readonly value: string | undefined;
    readonly defaultValue: string | undefined;
    readonly onChange: Dispatch<SetStateAction<string>>;
}

export const WidgetBorderRadiusPicker: FC<WidgetBorderRadiusPickerProps> = props => {
    return (
        <WidgetLengthPickerLine label={props.label ?? "Radius"} value={props.value} defaultValue={props.defaultValue} onChange={props.onChange} />
    );
};